(function Captcha($, Adzuki)
{
	"use strict";

	const Captcha = {};

	Captcha.init = function _init() {
		const $captcha_div = $('.captcha');

		// bail if no captcha element appears on the page
		if ($captcha_div.length === 0) {
			return;
		}

		const $spinner = $captcha_div.find('.captcha-spinner');
		const $img_div = $captcha_div.find('.captcha-img');
		const $img     = $('#captcha');
		const $refresh = $captcha_div.find('.refresh-captcha');

		// set the img src
		$img.attr('src', Adzuki.base_uri + '/Main/captcha/?' + new Date().getTime());

		// show loading animation until image has loaded.  Once loaded, hide spinner and show img
		$img.on('load', function _captchaLoaded() {
			$spinner.addClass('hidden d-none');
			$img_div.removeClass('hidden d-none');
		});

		// ability for user to click the reload icon and get a new captcha image. This will also end up resetting the session variable
		$refresh.on('click', function _reloadCaptcha(e) {
			const $self = $(this);
			const $icon = $self.find('i');

			e.preventDefault();

			$icon.addClass('fa-spin');
			$img.attr('src', Adzuki.base_uri + '/Main/captcha/?' + new Date().getTime());

			$img.on('load', function _captchaLoaded() {
				$icon.removeClass('fa-spin');
			});
		});
	};

	Adzuki.Captcha = Captcha;
}(jQuery, window.Adzuki || {}));
